import axios from 'axios';
import constants from 'src/constants/index';
import { getItem, getTokenData } from './localStorage';

const service = axios.create({
  baseURL: constants.SSO_URL,
  timeout: 180000,
});

service.interceptors.request.use(
  config => {
    const tokenData: any = JSON.parse(getTokenData());
    const sessionId = encodeURIComponent(
      getItem(constants.SSO_KEY_SESSION_ID) ?? '',
    );
    const eworkTokenData = encodeURIComponent(
      localStorage.getItem('eworkTokenData') ?? '',
    );
    if (tokenData !== undefined) {
      if (config.headers) {
        config.headers['Content-Type'] = 'application/json; charset=utf-8';
        config.headers['Accept'] = 'application/json';
        config.headers['Authorization'] = 'Bearer ' + tokenData.id_token;
        config.headers['SessionId'] = tokenData.sessionId;
        config.headers['eworkTokenData'] = eworkTokenData;
        config.headers['tenantCode'] = 'mobifone.vn';
      }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

// Response interceptors
service.interceptors.response.use(
  response => {
    const res = response.data;
    const responseStatus = response.status;
    if (
      responseStatus !== constants.AXIOS.HTTP_STATUS.SUCCESS
    ) {
      return Promise.reject(
        new Error(res.message || 'Error'),
      );
    } else {
      return response;
    }
  },
  error => {
    return Promise.reject(error);
  },
);

export default service;